import {
  appInfoCalledBy,
  findAppInfoTableContentById,
  findErrorState,
  findLoadingState,
  getAppInfoTotalColumns,
} from "./model";
import { useDispatch, useSelector } from "react-redux";
import { isEmptyArray } from "../../../../../../common/utils";
import {
  ApplicationDetailsActions,
  getAppInfoTabSelectedColumns,
  getAppInfoTabTotalColumns,
} from "../../../model";
import { InfoTabUsersTableContentActions } from "../../../../../../components/InfoTab/model";
import { useEffect } from "react";

export function AppInfoController(appInfo) {
  function checkIfInitialStateAndAppInfoTableContentIsLoaded() {
    return (
      copyAOEmails === "" &&
      copyGaaEmails === "" &&
      isEmptyArray(aoDataSource) &&
      isEmptyArray(gaaDataSource) &&
      appInfoTableDataSource.length > 0
    );
  }

  function getRequestUserIdList() {
    const gaaUserIdWithEmployeeIdAndRole = new Map();
    const gaaEmployeeIdMapping = new Map();

    const gaaUserIds = appInfo?.globalAccessApprovers?.map((gaa) => {
      gaaUserIdWithEmployeeIdAndRole.set(gaa.userId, { employeeId: gaa.employeeId, role: "GAA" });
      gaaEmployeeIdMapping.set(gaa.employeeId, "GAA");
      return gaa.userId;
    });
    const aoUserIds = appInfo?.accessOwnerList?.map((ao) => {
      if (gaaUserIdWithEmployeeIdAndRole.get(ao.userId)?.role === "GAA") {
        gaaEmployeeIdMapping.set(gaaUserIdWithEmployeeIdAndRole.get(ao.userId)?.employeeId, "BOTH");
        gaaUserIdWithEmployeeIdAndRole.set(ao.userId, { employeeId: ao.employeeId, role: "BOTH" });
      }
      return ao.userId;
    });

    const postRequestUserIdsList = gaaUserIds
      ?.concat(aoUserIds?.filter((item) => gaaUserIds?.indexOf(item) < 0))
      .join();
    return { postRequestUserIdsList, gaaEmployeeIdMapping };
  }

  function initializeActiveColumns() {
    const totalColumns = getAppInfoTotalColumns(appInfo?.id).map((column) => column.title);
    selectedColumns = selectedColumns?.length > 0 ? selectedColumns : totalColumns;
    dispatch(
      ApplicationDetailsActions.setAppInfoActiveColumns({
        appId: appInfo?.id,
        totalColumns,
        selectedColumns,
      })
    );
  }

  function loadAoAndGaaDataGource() {
    let gaaEmail = [];
    let aoEmail = [];
    let gaaDataSource = [];
    let aoDataSource = [];
    appInfoTableDataSource.map((userData) => {
      switch (gaaEmployeeIdMapping.get(userData.user.second)) {
        case "GAA": {
          gaaEmail.push(userData.email);
          gaaDataSource.push(userData);
          break;
        }
        case "BOTH": {
          gaaEmail.push(userData.email);
          gaaDataSource.push(userData);
          aoEmail.push(userData.email);
          aoDataSource.push(userData);
          break;
        }
        default: {
          aoEmail.push(userData.email);
          aoDataSource.push(userData);
          break;
        }
      }
      return null;
    });
    gaaEmail = gaaEmail.join(",");
    aoEmail = aoEmail.join(",");
    dispatch(
      InfoTabUsersTableContentActions.setUpGaaAndAoDataSourceAndEmails({
        appId: appInfo?.id,
        gaaEmail,
        aoEmail,
        gaaDataSource,
        aoDataSource,
      })
    );
  }

  const { postRequestUserIdsList, gaaEmployeeIdMapping } = getRequestUserIdList();

  const dispatch = useDispatch();

  let appInfoTableContent = useSelector((rootState) =>
    findAppInfoTableContentById(rootState.InfoTabUsersTableContent, appInfo?.id)
  );
  const isLoading = useSelector((rootState) =>
    findLoadingState(rootState.InfoTabUsersTableContent, appInfo?.id)
  );
  const errorState = useSelector((rootState) =>
    findErrorState(rootState.InfoTabUsersTableContent, appInfo?.id)
  );
  let selectedColumns = useSelector((rootState) =>
    getAppInfoTabSelectedColumns(rootState.appDetails, appInfo?.id)
  );
  let totalColumns = useSelector((rootState) =>
    getAppInfoTabTotalColumns(rootState.appDetails, appInfo?.id)
  );

  let copyAOEmails = "";
  let copyGaaEmails = "";
  let aoDataSource = [];
  let gaaDataSource = [];
  let columns = [];

  const isErrorState = !(errorState === null || errorState === undefined);

  useEffect(() => {
    if (appInfoTableContent === undefined) {
      if (appInfo?.id !== undefined) {
        dispatch(
          InfoTabUsersTableContentActions.getInfoTabUsersTableContent({
            calledBy: appInfoCalledBy,
            appId: appInfo?.id,
            usersList: postRequestUserIdsList,
          })
        ).then(() => {
          initializeActiveColumns();
        });
      }
    }
  }, [appInfoTableContent, appInfo?.id]);

  const appInfoTableDataSource = appInfoTableContent?.data?.value?.dataSource;
  columns = appInfoTableContent?.data?.value?.columns;
  copyAOEmails = appInfoTableContent?.copyAoEmails;
  copyGaaEmails = appInfoTableContent?.copyGaaEmails;
  aoDataSource = appInfoTableContent?.aoDataSource;
  gaaDataSource = appInfoTableContent?.gaaDataSource;

  useEffect(() => {
    if (checkIfInitialStateAndAppInfoTableContentIsLoaded()) {
      loadAoAndGaaDataGource();
    }
  }, [checkIfInitialStateAndAppInfoTableContentIsLoaded()]);

  const setSelectedColumns = (selectedColumns) => {
    dispatch(
      ApplicationDetailsActions.setAppInfoActiveColumns({
        selectedColumns,
        appId: appInfo?.id,
        totalColumns,
      })
    );
  };

  return {
    copyAOEmails,
    copyGaaEmails,
    gaaDataSource,
    aoDataSource,
    columns,
    isLoading,
    selectedColumns,
    totalColumns,
    setSelectedColumns,
    isErrorState,
  };
}
